import { render } from "./FilesEmptyPreview.vue?vue&type=template&id=54d4a994&scoped=true"
import script from "./FilesEmptyPreview.vue?vue&type=script&lang=js"
export * from "./FilesEmptyPreview.vue?vue&type=script&lang=js"

import "./FilesEmptyPreview.vue?vue&type=style&index=0&id=54d4a994&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d4a994"]])

export default __exports__